import * as DiagnosticDataConstant from './DiagnisticDataConstants';
import { produce } from "immer";
import { STATUS_FAILURE, STATUS_PENDING, STATUS_SUCCESS, STATUS_RESET } from 'Common/constants/commonConstants';

export default function DiagnosticsDataReducer(state = {}, action) {

    switch (action.type) {

        case DiagnosticDataConstant.DIAGNOSTIC_SUPPORT_FETCHED:{
           
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isDiagSupportFetched: true,
                    analyzerUnitSupported: action.newState.analyzerUnitSupported,
                    diagnosticSupported: action.newState.diagnosticSupported
                }
            });
        }

        case DiagnosticDataConstant.DIAGNOSTIC_TYPE_FETCHING:{
           
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagTypeFetchStatus: STATUS_PENDING,
                    diagnosticType: [],
                    diagTypeFilterData: []
                }
            });
        }

        case DiagnosticDataConstant.DIAGNOSTIC_TYPE_FETCHED: {

            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagTypeFetchStatus: STATUS_SUCCESS,
                    diagnosticType: action.newState.diagnosticType,
                    dateFilterData: []
                }
            });
        }

        case DiagnosticDataConstant.DIAG_TYPE_FILTER_RESULT: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagTypeFilterData: [action.newState],
                }
            });
        }

        case DiagnosticDataConstant.DIAG_TYPE_FILTER_OPTIONS: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagTypeFilterOptions: action.newState,
                    dateOptions: [],
                }
            });
        }

        case DiagnosticDataConstant.ANALYZER_FILTER_RESULT: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isUnitFilterFetched: true,
                    analyzerUnitFilterData: [action.newState]
                }
            });
        }

        case DiagnosticDataConstant.ANALYZER_FILTER_SHOW: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isUnitFilterShow: action.newState
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_FILTERS_SHOW: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isPhotocalFilterShow: action.newState
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_FILTERS_WAVELENGTH_SHOW: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isPhotocalWavelengthFilterShow: action.newState,
                    photocalWavelengthFilterFetchStatus: STATUS_PENDING
                }
            });
        }

        case DiagnosticDataConstant.FILTER_DATE_RESULT: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    dateFilterData: [action.newState]
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_FILTERED_DATA: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    photocalMonitorFilteredData: action.newState
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_WAVELENGTH_FILTER_DATA: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    photocalWavelengthFilterFetchStatus: STATUS_SUCCESS,
                    photocalMonitorWavelengthFilterData: [action.newState]
                }
            });
        }

        case DiagnosticDataConstant.ANALYZER_UNIT_OPTIONS: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    analyzerUnitOptions: action.newState,
                }
            });
        }

        case DiagnosticDataConstant.DATE_OPTIONS: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    dateOptions: action.newState
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_CUVETTE_FILTER_RESULT: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    photocalMonitorCuvetteFilterData: [action.newState]
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_CUVETTE_OPTIONS: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    photocalMonitorCuvetteOptions: action.newState
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_WAVELENGTH_OPTIONS: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    photocalMonitorWaveLengthOptions: action.newState
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_GRAPH_DATA: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    photocalMonitorGraphData: action.newState
                }
            });
        }

        case DiagnosticDataConstant.ANALYZER_UNIT_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    analyzerUnitFetchStatus : STATUS_PENDING,
                    unitList: []
                }
            });
        }

        case DiagnosticDataConstant.ANALYZER_UNIT_FETCHED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    analyzerUnitFetchStatus : STATUS_SUCCESS,
                    unitList: action.newState.unitList
                }
            });
        }

        case DiagnosticDataConstant.ANALYZER_UNIT_FETCHING_FAILURE: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    analyzerUnitFetchStatus : STATUS_FAILURE,
                    unitList: []
                }
            });
        }

        case DiagnosticDataConstant.DATE_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    dateFetchStatus: STATUS_PENDING,
                    dateList: []
                }
            });
        }

        case DiagnosticDataConstant.DATE_FETCHED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    dateFetchStatus: STATUS_SUCCESS,
                    dateList: action.newState.dateList
                }
            });
        }

        case DiagnosticDataConstant.DATE_FETCHING_FAILURE: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    dateFetchStatus: STATUS_FAILURE,
                    dateList: []
                }
            });
        }

        case DiagnosticDataConstant.DIAGONSTIC_DATA_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagDataFetchStatus: STATUS_PENDING,
                    diagData: []
                }
            });
        }

        case DiagnosticDataConstant.DIAGONSTIC_DATA_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagDataFetchStatus: STATUS_RESET,
                    diagData: []
                }
            });
        }

        case DiagnosticDataConstant.DIAGONSTIC_DATA_FETCHED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagDataFetchStatus: STATUS_SUCCESS,
                    diagData: action.newState
                }
            });
        }

        case DiagnosticDataConstant.DIAGONSTIC_DATA_FETCHING_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    diagDataFetchStatus: STATUS_FAILURE,
                    diagData: []
                }
            });
        }

        case DiagnosticDataConstant.DEVICE_DETAILS: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    deviceID: action.deviceID,
                    model: action.modelName,
                    region: action.region,
                    timezone: action.instrTimeZone
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_EXPORT_CSV_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isExportCSVDataFetched: false,
                    isExportCSVDataFetching: true,
                    isExportCSVDataFailed: false,
                    exportCSVPhotocalData: []
                }
            });
        }

        case DiagnosticDataConstant.PHOTOCAL_EXPORT_CSV_FETCHED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isExportCSVDataFetched: true,
                    isExportCSVDataFetching: false,
                    isExportCSVDataFailed: false,
                    exportCSVPhotocalData: action.newState
                }
            });
        }

        case DiagnosticDataConstant.DIAGONSTIC_DATA_FETCHING_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isExportCSVDataFetched: false,
                    isExportCSVDataFetching: false,
                    isExportCSVDataFailed: true,
                    exportCSVPhotocalData: []
                }
            });
        }

        case DiagnosticDataConstant.ANALYZER_FILTER_RESULT_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    isUnitFilterFetched: false,
                    analyzerUnitFilterData: []
                }
            });
        }

        case DiagnosticDataConstant.FILTER_DATE_RESULT_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    dateFilterData: []
                }
            });
        }
        case DiagnosticDataConstant.PHOTOCAL_CUVETTE_FILTER_RESULT_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    photocalMonitorCuvetteFilterData: []
                }
            });
        }

        case DiagnosticDataConstant.PIPETTOR_MATCH_DATA_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    pipettorMatchFetchStatus: STATUS_PENDING,
                    // Initialize pagination state on first fetch
                    pipettorMatchData: draft[action.deviceID]?.pipettorMatchData || {
                        data: [],
                        hasMore: true,
                        nextCursor: null,
                        pageSize: 20,
                        isFirstPage: true
                    },
                    pipettorMatchLoadingMore: !draft[action.deviceID]?.pipettorMatchData?.data?.length
                }
            });
        }

        case DiagnosticDataConstant.PIPETTOR_MATCH_DATA_FETCHED: {
            return produce(state, (draft) => {
                const existingData = draft[action.deviceID]?.pipettorMatchData?.data || [];
                const newData = action.newState?.data || [];
                
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    pipettorMatchFetchStatus: STATUS_SUCCESS,
                    pipettorMatchLoadingMore: false,
                    pipettorMatchData: {
                        data: action.isLoadMore ? [...existingData, ...newData] : newData,
                        hasMore: action.newState?.hasMore || false,
                        nextCursor: action.newState?.nextCursor || null,
                        pageSize: action.newState?.pageSize || 20,
                        isFirstPage: action.newState?.isFirstPage || false,
                        dateRange: action.newState?.dateRange || null
                    }
                }

            });
        }

        case DiagnosticDataConstant.PIPETTOR_MATCH_DATA_FETCHING_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    pipettorMatchFetchStatus: STATUS_FAILURE,
                    pipettorMatchLoadingMore: false
                }
            });
        }

        case DiagnosticDataConstant.PIPETTOR_MATCH_DATA_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    pipettorMatchData: {
                        data: [],
                        hasMore: true,
                        nextCursor: null,
                        pageSize: 20,
                        isFirstPage: true
                    },
                    pipettorMatchFetchStatus: STATUS_RESET,
                    pipettorMatchLoadingMore: false
                }
            });
        }

        case DiagnosticDataConstant.CARRYOVER_SUMMARY_DATA_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    carryoverSummaryData: {
                        list: [],
                        hasMore: true,
                        nextCursor: null,
                        pageSize: 25
                    },
                    carryoverSummaryDataStatus: STATUS_RESET,
                    carryoverSummaryLoadingMore: false
                }
            });
        }

        // PipettorMatch Report Reducer Cases
        case DiagnosticDataConstant.PIPETTOR_MATCH_REPORT_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    pipettorMatchReportStatus: STATUS_PENDING,
                    pipettorMatchReportData: null,
                    pipettorMatchReportError: null
                }
            });
        }

        case DiagnosticDataConstant.PIPETTOR_MATCH_REPORT_FETCHED: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    pipettorMatchReportStatus: STATUS_SUCCESS,
                    pipettorMatchReportData: action.payload,
                    pipettorMatchReportError: null
                }
            });
        }

        case DiagnosticDataConstant.PIPETTOR_MATCH_REPORT_FETCHING_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    pipettorMatchReportStatus: STATUS_FAILURE,
                    pipettorMatchReportData: null,
                    pipettorMatchReportError: action.payload
                }
            });
        }

        // CarryOver Report Reducer Cases
        case DiagnosticDataConstant.CARRYOVER_REPORT_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    carryOverReportStatus: STATUS_PENDING,
                    carryOverReportData: null,
                    carryOverReportError: null
                }
            });
        }

        case DiagnosticDataConstant.CARRYOVER_REPORT_FETCHED: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    carryOverReportStatus: STATUS_SUCCESS,
                    carryOverReportData: action.payload,
                    carryOverReportError: null
                }
            });
        }

        case DiagnosticDataConstant.CARRYOVER_REPORT_FETCHING_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    carryOverReportStatus: STATUS_FAILURE,
                    carryOverReportData: null,
                    carryOverReportError: action.payload
                }
            });
        }
        
        // CarryoverSummary Data Reducer Cases
        case DiagnosticDataConstant.CARRYOVER_SUMMARY_DATA_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    carryoverSummaryDataStatus: STATUS_PENDING,
                    carryoverSummaryDataError: null
                }
            });
        }

        case DiagnosticDataConstant.CARRYOVER_SUMMARY_DATA_FETCHED: {
            return produce(state, (draft) => {
                const existingData = state[action.deviceId]?.carryoverSummaryData?.list || [];
                const newData = action.payload?.carryoverSummaryList || [];
                
                // For first page or if cursor is null, reset the data
                const mergedData = action.isFirstCall ? newData : [...existingData, ...newData];
                
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    carryoverSummaryDataStatus: STATUS_SUCCESS,
                    carryoverSummaryData: {
                        list: mergedData,
                        hasMore: action.payload?.hasMore || false,
                        nextCursor: action.payload?.nextCursor || null,
                        pageSize: action.payload?.pageSize || 25,
                        dateRange: action.payload?.dateRange || null
                    },
                    carryoverSummaryDataError: null
                }
            });
        }

        case DiagnosticDataConstant.CARRYOVER_SUMMARY_DATA_FETCHING_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    carryoverSummaryDataStatus: STATUS_FAILURE,
                    carryoverSummaryData: null,
                    carryoverSummaryDataError: action.payload
                }
            });
        }

        case DiagnosticDataConstant.LOWVOLUME_DATA_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    lowVolumeFetchStatus: STATUS_PENDING,
                    // Initialize pagination state on first fetch
                    lowVolumeData: draft[action.deviceID]?.lowVolumeData || {
                        data: [],
                        hasMore: true,
                        nextCursor: null,
                        pageSize: 20,
                        isFirstPage: true
                    },
                    lowVolumeLoadingMore: !draft[action.deviceID]?.lowVolumeData?.data?.length
                }
            });
        }

        case DiagnosticDataConstant.LOWVOLUME_DATA_FETCHED: {
            return produce(state, (draft) => {
                const existingData = draft[action.deviceID]?.lowVolumeData?.data || [];
                const newData = action.newState?.data || [];
                
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    lowVolumeFetchStatus: STATUS_SUCCESS,
                    lowVolumeLoadingMore: false,
                    lowVolumeData: {
                        data: action.isLoadMore ? [...existingData, ...newData] : newData,
                        hasMore: action.newState?.hasMore || false,
                        nextCursor: action.newState?.nextCursor || null,
                        pageSize: action.newState?.pageSize || 20,
                        isFirstPage: action.newState?.isFirstPage || false,
                        dateRange: action.newState?.dateRange || null
                    }
                }
                
            });
        }

        case DiagnosticDataConstant.LOWVOLUME_DATA_FETCH_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    lowVolumeFetchStatus: STATUS_FAILURE,
                    lowVolumeLoadingMore: false
                }
            });
        }

        case DiagnosticDataConstant.LOWVOLUME_DATA_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    lowVolumeData: {
                        data: [],
                        hasMore: true,
                        nextCursor: null,
                        pageSize: 20,
                        isFirstPage: true
                    },
                    lowVolumeFetchStatus: STATUS_RESET,
                    lowVolumeLoadingMore: false
                }
            });
        }

        // LowVolume Report Reducer Cases
        case DiagnosticDataConstant.LOWVOLUME_REPORT_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    lowVolumeReportStatus: STATUS_PENDING,
                    lowVolumeReportData: null,
                    lowVolumeReportError: null
                }
            });
        }

        case DiagnosticDataConstant.LOWVOLUME_REPORT_FETCHED: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    lowVolumeReportStatus: STATUS_SUCCESS,
                    lowVolumeReportData: action.payload,
                    lowVolumeReportError: null
                }
            });
        }

        case DiagnosticDataConstant.LOWVOLUME_REPORT_FETCH_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceId] = {
                    ...draft[action.deviceId],
                    lowVolumeReportStatus: STATUS_FAILURE,
                    lowVolumeReportData: null,
                    lowVolumeReportError: action.payload
                }
            });
        }

        case DiagnosticDataConstant.SYSTEM_CHECK_DATA_FETCHING: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    systemCheckFetchStatus: STATUS_PENDING,
                    // Initialize pagination state on first fetch
                    systemCheckData: draft[action.deviceID]?.systemCheckData || {
                        data: [],
                        hasMore: true,
                        nextCursor: null,
                        pageSize: 20,
                        isFirstPage: true
                    },
                    systemCheckLoadingMore: !draft[action.deviceID]?.systemCheckData?.data?.length
                }
            });
        }

        case DiagnosticDataConstant.SYSTEM_CHECK_DATA_FETCHED: {
            return produce(state, (draft) => {
                const existingData = draft[action.deviceID]?.systemCheckData?.data || [];
                const newData = action.newState?.data || [];
                
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    systemCheckFetchStatus: STATUS_SUCCESS,
                    systemCheckLoadingMore: false,
                    systemCheckData: {
                        data: action.isLoadMore ? [...existingData, ...newData] : newData,
                        hasMore: action.newState?.hasMore || false,
                        nextCursor: action.newState?.nextCursor || null,
                        pageSize: action.newState?.pageSize || 20,
                        isFirstPage: action.newState?.isFirstPage || false,
                        dateRange: action.newState?.dateRange || null
                    }
                }
            });
        }

        case DiagnosticDataConstant.SYSTEM_CHECK_DATA_FETCH_FAILED: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    systemCheckFetchStatus: STATUS_FAILURE,
                    systemCheckLoadingMore: false
                }
            });
        }

        case DiagnosticDataConstant.SYSTEM_CHECK_DATA_RESET: {
            return produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    systemCheckData: {
                        data: [],
                        hasMore: true,
                        nextCursor: null,
                        pageSize: 20,
                        isFirstPage: true
                    },
                    systemCheckFetchStatus: STATUS_RESET,
                    systemCheckLoadingMore: false
                }
            });
        }

        // SystemCheck Report Reducer Cases
        case DiagnosticDataConstant.SYSTEM_CHECK_REPORT_FETCHING: {
            return produce(state, (draft) => {
            draft[action.deviceId] = {
                ...draft[action.deviceId],
                systemCheckReportStatus: STATUS_PENDING,
                systemCheckReportData: null,
                systemCheckReportError: null
            }
            });
        }

        case DiagnosticDataConstant.SYSTEM_CHECK_REPORT_FETCHED: {
            return produce(state, (draft) => {
            draft[action.deviceId] = {
                ...draft[action.deviceId],
                systemCheckReportStatus: STATUS_SUCCESS,
                systemCheckReportData: action.payload,
                systemCheckReportError: null
            }
            });
        }

        case DiagnosticDataConstant.SYSTEM_CHECK_REPORT_FETCH_FAILED: {
            return produce(state, (draft) => {
            draft[action.deviceId] = {
                ...draft[action.deviceId],
                systemCheckReportStatus: STATUS_FAILURE,
                systemCheckReportData: null,
                systemCheckReportError: action.payload
            }
            });
        }
        
        default:
        return state;

    }

}
